<template>
   <div>

      <v-autocomplete ref="myAutocomplete"
         v-model="options.selected"
         :items="items"
         :loading="isLoading"
         :search-input.sync="search"
         chips
         hide-details
         auto-select-first
         deletable-chips
         :rules="options.rules"
         :required="options.required"
         :disabled="options.disabled"
         :hide-selected="options.hide_selected"
         :return-object="options.return_object"
         :clearable="options.clearable"
         :multiple="options.multiple"
         :item-text="options.item_text"
         :item-value="options.item_value"
         :item-disabled="options.item_disabled"
         :label="options.label"
         :filter="filterMethod"
         v-on:change="change"
         @click:clear="change"
      >

         <template v-slot:selection="data">
            <slot name="selection" :item="data.item" :selected="data.selected" :attrs="data.attrs" :on="data.on" v-scope="data">
               <p>???</p>
            </slot>
         </template>

         <template v-slot:item="data">
            <slot name="item" :item="data.item" v-scope="data">
               <p>???</p>
            </slot>
         </template>

      </v-autocomplete>

    </div> 
</template>

<script>
export default {
   name: 'ddoSelect2',
   props: {
      callbacks: {
         type: Object,
         default: function () {
            return {};
         }
      },
      options: {
         type: Object,
         default: function () {
            return {
               selected: [],
               disabled: false,
               search_refresh: false,
            };
         }
      },
   },
   data: () => {
      return {
         isLoading: false,
         items: [],
         model: null,
         search: null,
         tab: null,
         filterMethod : null,
         search_value: null,
      }
   },

   created() {
      //console.log('ddoSelect2::created, callbacks='+JSON.stringify(this.callbacks))
   },

   async mounted() {
      //console.log('ddoSelect2::mounted, callbacks='+JSON.stringify(this.callbacks))
      if ( this.callbacks.filterMethod ) {
       this.filterMethod = this.callbacks.filterMethod; 
      } else {
       this.filterMethod = this.defaultfilterMethod; 
      }
      await this.refresh_rows();
      this.$emit('itemsLoaded',this.items);
   },

   watch: {

      search: function (val) {
         //console.log('ddoSelect2::watch::search, val='+val+', options.search_refresh='+this.options.search_refresh)
         if ( val!=null && this.options.search_refresh==true) {
            this.search_function(val);
         }
      }

   },

   methods: {

      defaultfilterMethod(item, queryText, itemText) {
         return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      },

      async refresh_rows(key=null) {
         //console.log('ddoSelect2::refresh_rows, key='+key+', search_value='+this.search_value);
         //console.log('ddoSelect2::refresh_rows, callbacks='+JSON.stringify(this.callbacks))
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            //console.log('ddoSelect2::refresh_rows, callback called');
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(key,this.search_value);
            if ( api_response && api_response.error==0 && api_response.rows ) {
               var raw_rows = api_response.rows;
            } else {
               var raw_rows = [];
            }
            this.items = raw_rows;
         } else {
            //console.log('ddoSelect2::refresh_rows, NO callback, this.callbacks.refresh_rows='+typeof this.callbacks.refresh_rows);
         }
      },

      async remove(item) {
         //console.log('remove, item='+JSON.stringify(item))
         if ( typeof item._pk != "undefined" ) {
            if ( typeof this.callbacks.remove == 'function' ) {
               this.callbacks.remove(item);
            }
            if ( this.options.selected instanceof Object ) {
               if ( item._pk==this.options.selected._pk ) {
                  this.options.selected = null;
               }
            } else {
               if ( Array.isArray(this.options.selected) ) {
                  this.$api._remove_by_pk(this.options.selected,item._pk);
               } else {
                  if ( item._pk==this.options.selected ) {
                     this.options.selected = null;
                  }
               }
            }
         }
         if ( this.options.change_on_remove ) {
            await this.change(this.options.selected,null)
         }
      },

      async search_function(value) {
         this.search_value = value;         
         await this.refresh_rows();
      },

      async change(values,item=null) {
         //console.log('ddoSelect2::change, STANDARD, values='+values);
         if ( typeof this.callbacks.change == 'function' ) {
            await this.callbacks.change(values,item);
         }
      },

   },

}
</script>